import React, { useEffect } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const KimyaBolumuSanalTur = () => {
    const { t } = useTranslation();

    useEffect(() => {
        // CloudPano script'i yükle
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.setAttribute('data-short', 'CgBO-UWBf');
        script.setAttribute('data-path', 'tours');
        script.setAttribute('data-is-self-hosted', 'undefined');
        script.setAttribute('width', '100%');
        script.setAttribute('height', '500px');
        script.src = 'https://app.cloudpano.com/public/shareScript.js';

        const container = document.getElementById('cloudpano-container');
        if (container) {
            container.appendChild(script);
        }

        return () => {
            // Cleanup: script'i kaldır
            if (container && script.parentNode) {
                container.removeChild(script);
            }
        };
    }, []);

    return (
        <PageTemplate
            title={t('virtualTour.title')}
            subtitle={t('virtualTour.subtitle')}
        >
            <div className="w-full px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="bg-white rounded-lg shadow-lg p-4 sm:p-6 lg:p-8"
                >
                    <div className="mb-4 sm:mb-6 lg:mb-8">
                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800 mb-2 sm:mb-3 lg:mb-4 text-center">
                            {t('virtualTour.pageTitle')}
                        </h2>
                        <p className="text-sm sm:text-base lg:text-lg text-gray-600 text-center mb-3 sm:mb-4 lg:mb-6 px-2">
                            {t('virtualTour.description')}
                        </p>
                    </div>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        className="w-full rounded-lg overflow-hidden shadow-xl"
                        style={{
                            minHeight: '400px',
                            height: '70vh',
                            maxHeight: '800px',
                            position: 'relative'
                        }}
                    >
                        <div
                            id="cloudpano-container"
                            style={{
                                width: '100%',
                                height: '100%',
                                minHeight: '400px'
                            }}
                        />
                    </motion.div>

                    <div className="mt-4 sm:mt-6 lg:mt-8 text-center text-gray-600">
                        <p className="text-xs sm:text-sm">
                            {t('virtualTour.tip')}
                        </p>
                    </div>
                </motion.div>
            </div>
        </PageTemplate>
    );
};

export default KimyaBolumuSanalTur;
